import React from "react";
import { useSelector } from "react-redux"; 
import "./style.scss";
import Avatar from "antd/lib/avatar";
import List from "antd/lib/list";
import Modal from "antd/lib/modal";
import { ENV } from "../../config";
const StoreModal = ({
  visible,
  handleCancel = () => {}, 
  store,
  handleOk,
}) => {
  const store_id = useSelector((state) => state.rootStore.storeId); 
  return (
    <>
      <Modal
        title={""}
        open={visible}
        footer={null}
        onCancel={handleCancel}
        getContainer={false}
        forceRender
        width={400}
        className="switch_store_modal"
      >
        <div className="box__shadow">
          <List
            className="store__listing__box"
            size="small"
            header={
              <p className="text-center text-heading mh">Select A Store</p>
            }
            bordered
            dataSource={store}
            renderItem={(item) => (
              <List.Item
                onClick={() => handleOk(item)}
                style={{ cursor: "pointer" }}
                className={
                  store.length == 1 || item.store_id == store_id
                    ? "selected"
                    : "not_selected"
                }
              >
                <List.Item.Meta
                  avatar={
                    item.store_image ? (
                      <Avatar
                        src={`${ENV.s3MediaBaseUrl}store-image/${item.store_image}`}
                      />
                    ) : (
                      <Avatar
                        size="large"
                        style={{
                          verticalAlign: "middle",
                          color: "black",
                          fontSize: 12,
                          fontWeight: 500,
                        }}
                      >{`${item.first_name.charAt(0)}${item.last_name.charAt(0)}`}
                     
                      </Avatar>
                    )
                  }
                  title={item.store_name}
                />
              </List.Item>
            )}
          />
        </div>
      </Modal>
    </>
  );
};

export default StoreModal;
